<p-table #dt [value]="atcPaged.content" [lazy]="true" (onLazyLoad)="lazyRead($event)" [paginator]="true"
  [rows]="pageSize" [totalRecords]="atcPaged.totalElements" [loading]="loading" dataKey="id" class="col-12 p-0">

  <ng-template pTemplate="colgroup" let-columns>
    <colgroup class="hide-on-small">
      <col data-id="id" [style.width.px]="150">
      <col data-id="name">
      <col data-id="parent" [style.width.px]="150">
      <col data-id="actions" [style.width.px]="65" *ngIf="isDoctor">
    </colgroup>
  </ng-template>

  <ng-template pTemplate="header">
    <tr>
      <th scope="id">{{screen.labels.code}}</th>
      <th scope="name">{{screen.labels.name}}</th>
      <th scope="parent" rowspan="2">{{screen.labels.parentCode}}</th>
      <th scope="actions" rowspan="2" *ngIf="isDoctor"></th>
    </tr>

    <tr>
      <th scope="id+nam" colspan="2">
        <input pInputText type="text" name="dtNameFilter" [(ngModel)]="dtNameFilter"
          (input)="dt.filter(dtNameFilter, 'name', 'contains')">
      </th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-atc>
    <tr>
      <td>{{atc.id}}</td>
      <td class="text-ellipsis">{{atc.name}}</td>
      <td>{{atc.parentId}}</td>
      <td *ngIf="isDoctor">
        <p-button type="button" styleClass="p-button-success p-button-rounded p-button-outlined"
          [pTooltip]="screen.actions.createAutocompletes" tooltipPosition="left" icon="fas fa-vial"
          [routerLink]="['/admin/general/atc', atc.id]">
        </p-button>
      </td>
    </tr>
  </ng-template>
</p-table>